import { Container, Row, Col } from 'react-bootstrap';
import { FaLinkedin, FaMapMarkerAlt, FaEnvelope, FaInfoCircle } from 'react-icons/fa';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer style={{ backgroundColor: '#f8f9fa', paddingTop: '40px', paddingBottom: '20px', marginTop: '50px', borderTop: '1px solid #dee2e6' }}>
            <Container>
                <Row className="gy-4">
                    {/* 1. KOLON: LOGO VE KISA BİLGİ */}
                    <Col xs={12} md={6} lg={3} className="text-center text-md-start">
                        <img src='/images/Un2.jpg' width={180} height={100} alt="Logo" style={{ objectFit: 'contain', marginBottom: '15px' }} />
                        <p style={{ fontSize: '0.85rem', color: '#6c757d', lineHeight: '1.6' }}>
                            ADP Endüstriyel Otomasyon Sistemleri olarak geleceğin teknolojilerini bugünden sunuyoruz.
                        </p>
                        <div className="d-flex justify-content-center justify-content-md-start gap-3 mt-2">
                            <a href="https://www.linkedin.com/in/adp-end%C3%BCstriyel-otomasyon-115a5825a/" target="_blank" rel="noopener noreferrer">
                                <img src='/images/Lnk.jpg' width={30} height={30} alt="LinkedIn" />
                            </a>
                            <a href="https://www.n11.com/magaza/adp" target="_blank" rel="noopener noreferrer">
                                <img src='/images/n12.jpg' width={80} height={28} alt="n11" style={{ objectFit: 'contain' }} />
                            </a>
                        </div>
                    </Col>

                    {/* 2. KOLON: KURUMSAL BAĞLANTILAR */}
                    <Col xs={6} md={3} lg={2} className="text-center text-md-start">
                        <h6 style={{ fontWeight: '800', textTransform: 'uppercase', marginBottom: '20px', color: '#2b2b2b' }}>Kurumsal</h6>
                        <ul className="list-unstyled" style={{ fontSize: '0.9rem', lineHeight: '2.2' }}>
                            <li><a href="/aboutus" className="text-decoration-none text-muted">Hakkımızda</a></li>
                            <li><a href="/secretpolicy" className="text-decoration-none text-muted">Gizlilik Sözleşmesi</a></li>
                            <li><a href="/userpolicy" className="text-decoration-none text-muted">Kullanıcı Sözleşmesi</a></li>
                            <li><a href="/returnpolicy" className="text-decoration-none text-muted">İade Şartları</a></li>
                        </ul>
                    </Col>

                    {/* 3. KOLON: GÜVENLİK/SERTİFİKA */}
                    <Col xs={6} md={3} lg={2} className="text-center">
                        <h6 style={{ fontWeight: '800', textTransform: 'uppercase', marginBottom: '20px', color: '#2b2b2b' }}>Güvenlik</h6>
                        <img src='/images/3D.jpg' width={130} height={100} alt="Secure Payment" style={{ objectFit: 'contain' }} />
                    </Col>

                    {/* 4. KOLON: İLETİŞİM BİLGİLERİ */}
                    <Col xs={12} md={12} lg={5} className="text-center text-md-start">
                        <h6 style={{ fontWeight: '800', textTransform: 'uppercase', marginBottom: '20px', color: '#2b2b2b' }}>Bize Ulaşın</h6>
                        <div style={{ fontSize: '0.9rem', color: '#444' }}>
                            <p className="mb-2 d-flex align-items-center justify-content-center justify-content-md-start">
                                <FaEnvelope className="me-2" style={{ color: '#004488' }} /> 
                                <strong>Satış:</strong>&nbsp;satis@adpotomasyon.com.tr
                            </p>
                            <p className="mb-2 d-flex align-items-center justify-content-center justify-content-md-start">
                                <FaInfoCircle className="me-2" style={{ color: '#004488' }} /> 
                                <strong>Bilgi:</strong>&nbsp;info@adpotomasyon.com.tr
                            </p>
                            <p className="mb-0 d-flex align-items-start justify-content-center justify-content-md-start">
                                <FaMapMarkerAlt className="me-2 mt-1" style={{ color: '#004488' }} />
                                <span>Mandıra Cad. Teker Sok. No:2/D Kadıköy-İstanbul</span>
                            </p>
                        </div>
                    </Col>
                </Row>

                {/* ALT BİLGİ ÇİZGİSİ */}
                <hr className="mt-5 mb-4" />
                <Row>
                    <Col className="text-center">
                        <p style={{ fontSize: '0.8rem', color: '#999' }}>
                            &copy; {currentYear} ADP Endüstriyel Otomasyon. Tüm Hakları Saklıdır.
                        </p>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;
